// Simple in-memory cache for API responses
const cache = new Map();
const CACHE_DURATION = 60000; // 60 seconds (increased for better performance)
const LONG_CACHE_DURATION = 300000; // 5 minutes for rarely changing data

export const apiCache = {
  get: (key) => {
    const cached = cache.get(key);
    if (!cached) return null;
    
    // Use longer duration for settings and rates
    const duration = key.includes('settings') || key.includes('rate') || key.includes('limits') 
      ? LONG_CACHE_DURATION 
      : CACHE_DURATION;
    
    if (Date.now() - cached.timestamp > duration) {
      cache.delete(key);
      return null;
    }
    
    return cached.data;
  },
  
  set: (key, data) => {
    cache.set(key, {
      data,
      timestamp: Date.now()
    });
  },
  
  clear: (keyPattern) => {
    if (keyPattern) {
      for (const key of cache.keys()) {
        if (key.includes(keyPattern)) {
          cache.delete(key);
        }
      }
    } else {
      cache.clear();
    }
  },
  
  invalidate: (key) => {
    cache.delete(key);
  }
};

// Debounce function for API calls
export const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    return new Promise((resolve) => {
      timeoutId = setTimeout(() => resolve(fn(...args)), delay);
    });
  };
};

// Throttle function for frequent updates
export const throttle = (fn, limit) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      fn(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};
